<template>
    <div id="projects" class="mx-auto lg:w-9/12 w-10/12 py-12 border-b">
        <h2 class="text-xl font-medium tracking-widest text-gray-400">PROJECTS</h2>
        <div class="flex flex-col lg:flex-row mt-10" v-for="(project, index) in projects" :key="index">
            <div class="w-full lg:w-4/12 p-0">
                <img :src="getImgUrl(project.image)" class="w-full border">
            </div>
            <div class="w-full lg:w-8/12 px-3 lg:py-1 py-5">
                <h3 class="text-lg text-gray-700 font-medium">
                    {{ project.name }}
                </h3>
                <div class="mt-3">
                    {{ project.description }}
                </div>
                <h5 class="mt-5">STACK USED:</h5>
                <div class="mt-3 flex flex-wrap gap-4">
                    <span v-for="(stack, i) in project.stacks" :key="i" class="inline-block py-1 px-2 font-medium text-xs hover:bg-indigo-500 hover:text-white shadow text-gray-600 rounded">{{ stack }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => {
        return {
            projects: [
                {
                    name: 'HEALTHCARE COMMUNITY',
                    description: "Working at a Healthcare startup, developing the complete backend of a complex healthcare social networking application for a large user base.",
                    stacks: ['Laravel', 'MySQL', 'AWS', 'WebSocket'],
                    image: 'health.jpg'
                },
                {
                    name: 'MUSIC STREAMING PLATEFORM',
                    description: "Working on a Assamese music streaming application, developing the complete backend & frontend of the application for a customize music listening experience.",
                    stacks: ['Laravel', 'MySQL', 'Vue', 'Tailwind'],
                    image: 'music.jpg'
                },
                {
                    name: 'REAL TIME CHAT APPLICATION',
                    description: "A Real-Time chat web application for the users. It has all the common features like - text messaging, file sending, image sending, emoji, one to one video calling, message read indicator, online indicator, typing indicator etc.",
                    stacks: ['Laravel', 'MySQL', 'Vue Js', 'Tailwind css', 'WebRTC', 'WebSocket'],
                    image: 'chat.jpg'
                },
                {
                    name: 'LEAD MANANGEMENT SYSTEM',
                    description: "Working on a real-time lead management system for the real estate market. Targeting a large user base with possible quick real-time performance in the web app as well as in the mobile app & implementing strong data security features to keep data secure in the server.",
                    stacks: ['Node Js', 'Express Js', 'MongoDB', 'Socket.io', 'Vue Js', 'Quasar'],
                    image: 'lead.jpg'
                },
                {
                    name: 'JUDICIARY EMPLOYEE MANAGEMENT SYSTEM',
                    description: "An employee management system for all employees working on the different judiciaries in Assam. It has features like - employee transfer, promotion, notice board, profile management, leave management, I-Card generation, retired employee management etc.",
                    stacks: ['Laravel', 'MySQL', 'Bootstrap', 'JQuery'],
                    image: 'ems.jpg'
                },
                {
                    name: 'REAL ESTATE WEBSITE',
                    description: "Created 30+ websites for Banglore real estate market. Worked with top real estate builders & marketing partners like - Godrej, Assetz, Sobha, Brigade, Birla Estates, Puravankara, Lodha, Total Environment, Prestige, Hindustan Homes etc.",
                    stacks: ['PHP', 'JQuery', 'Bootstrap', 'Material'],
                    image: 'realestate.jpg'
                },
            ]
        }
    },
    methods: {
        getImgUrl(img) {
           return require('../assets/img/' + img)
        }
    }
}
</script>

<style scoped>
    .timeline{
        left: 6.5px;
        height: calc(100% - 18px)
    }
</style>